module.exports = __webpack_public_path__ + "static/media/logo.b0ab2326.svg";